import { Pipe, PipeTransform } from '@angular/core';
import { StepTypes } from 'src/app/components/steps/StepTypes';
@Pipe({
  name: 'step_type'
})

export class StepTypePipe implements PipeTransform {

  transform(type: number) {
    if (type == StepTypes.checkbox) {
        return 'Required Action'
    } else if (type == StepTypes.upload_file) {
        return 'Upload File'
    } else if (type == StepTypes.important_file_upload) {
        return 'Important File Upload'
    } else if (type == StepTypes.email) {
        return 'Secure Email'
    } else if (type == StepTypes.document_request) {
        return 'Document Request'
    }
    else if (type == StepTypes.signature_request) {
        return 'Signature Request'
    }
    else if (type == StepTypes.approval_request) {
        return 'Approval Request'
    }
    else if (type == StepTypes.survey) {
        return 'Form Request'
    }
    else if (type == StepTypes.payment_request) {
        return 'Payment Request'
    }
    else if (type == StepTypes.webhook) {
        return 'Webhook'
    }
    else if (type == StepTypes.standard_operating_procedure) {
        return 'Standard Operating Procedure Attached Document'
    }
    else if (type == StepTypes.conditional) {
        return 'If / Then'
    }
    else if (type == StepTypes.activate_client_portal) {
        return 'Activate Client Portal'
    } else if (type == StepTypes.appointment_request) {
        return 'Appointment Request'
    } else if (type == StepTypes.question_request) {
        return 'Question Request'
    } else if (type == StepTypes.checklist_request) {
        return 'Checklist Request'
    } else if (type == StepTypes.checklist) {
        return 'Checklist'
    }
    return type;
}

}
